module.exports = __webpack_public_path__ + "img/ico-export.2a242860.svg";